import React, { useState } from 'react';
import * as persianTools  from 'persian-tools';

export function convertNumbersToEnglish(number){
    let converted = persianTools.digitsFaToEn(number);
    converted = persianTools.digitsArToEn(converted);
    return converted; 
}

export function onlyDigits(number){
    return number.replace(/\D/g, ""); 
}